module.exports = "https://bper-network.servercdn.it/static/fonts/FuturaPT-Heavy.eot?6f586d0063dc5635a913782659c40a0d";